export default __webpack_public_path__ + "static/media/expose5.4c650b4b.png";